import React from 'react'
import { BoxHeader, BoxTitle, BoxBody } from '../../ui/box'
import { Row, Col } from '../../ui/grid'
import Memory from '../../helper/memory'
import Percent from '../../helper/percent'
import MilliSeconds from '../../helper/milliseconds'
import { FlamegraphNode, TraceMetric } from '../../domain/Trace'
import { TraceDetailsStacktrace } from '../tracedetails/TraceDetailsStacktrace'

interface Props {
    traceTotals: TraceMetric
    node: FlamegraphNode
    isAggregatedTrace: boolean
    sectionBelowTitle?: React.ReactNode
}

export class FrameSummary extends React.PureComponent<Props> {
    public render = () => {
        const { node, traceTotals, isAggregatedTrace, sectionBelowTitle } = this.props

        return (
            <>
                <BoxHeader>
                    <BoxTitle className="tw-mt-0" muted>
                        Summary
                    </BoxTitle>
                </BoxHeader>
                {sectionBelowTitle}
                <BoxBody>
                    <div className="tw-font-size-16 tw-mb-8">
                        <Row>
                            <Col width={4}>
                                {isAggregatedTrace ? <small>Average Call Count</small> : <small>Call Count</small>}
                                <br />
                                {node.stats.ct}
                            </Col>
                            <Col width={4}>
                                {isAggregatedTrace ? <small>Average Duration</small> : <small>Duration</small>}
                                <br />
                                <MilliSeconds value={node.values.wt} />
                                &nbsp; (<Percent value={traceTotals.wt > 0 ? node.values.wt / traceTotals.wt : 0} />)
                            </Col>
                            {node.values.mc > 0 ? (
                                <Col width={4}>
                                    {isAggregatedTrace ? <small>Average Memory</small> : <small>Memory</small>}
                                    <br />
                                    <Memory value={node.values.mc} />
                                    &nbsp; (<Percent value={traceTotals.mc > 0 ? node.values.mc / traceTotals.mc : 0} />)
                                </Col>
                            ) : null}
                        </Row>
                        {node.stack && node.stack.length > 0 ? <TraceDetailsStacktrace stack={node.stack} /> : null}
                    </div>
                </BoxBody>
            </>
        )
    }
}
